import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import Header from '../../components/Header';
import Sidebar from './Sidebar';
import UserService from '../../services/UserService';
import ContactUsWidget from '../../components/ContactUsWidget';
import OnboardingVideoModal from '../../modals/OnboardingVideoModal';
import { useUiStore } from '../../store';
import classes from './styles.module.scss';

export default function Layout({
  children,
  hasUserBlock = true,
  hasSearch,
  searchInput,
  setSearchInput,
  mainStyle,
  style,
  trainingPathPlaylist,
  searchPlaceholder,
}) {
  const isOnboardingVideoVisible = useUiStore((state) => state.isOnboardingVideoOpen);
  const setOnboardingVideoOpen = useUiStore((state) => state.setOnboardingVideoOpen);

  return (
    <div className={classes.Layout} style={style}>
      <TrialBanner />
      <ContactUsWidget />
      <div className={classes.main}>
        <Sidebar trainingPathPlaylist={trainingPathPlaylist} />
        <div className={classes.container}>
          <Header
            hasUserBlock={hasUserBlock}
            hasSearch={hasSearch}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            trainingPathPlaylist={trainingPathPlaylist}
            searchPlaceholder={searchPlaceholder}
          />
          <main style={mainStyle}>{children}</main>
        </div>
      </div>
      <OnboardingVideoModal
        show={isOnboardingVideoVisible}
        handleClose={() => setOnboardingVideoOpen(false)}
      />
    </div>
  );
}

function TrialBanner() {
  const { data: currentUser } = useQuery('me', UserService.getMe);
  const trialEndsAt = currentUser?.organizationBilling?.trialEndsAt;
  const isPaywalled = currentUser?.organizationBilling?.isPaywalled;
  const hasPaidAccess = currentUser?.organizationBilling?.hasPaidAccess;

  const isTrialExpiringSoon = useMemo(() => {
    if (!trialEndsAt) return false;
    const end = new Date(trialEndsAt);
    if (Number.isNaN(end.getTime())) return false;
    const days = (end.getTime() - Date.now()) / (1000 * 60 * 60 * 24);
    return days >= 0 && days <= 3 && !isPaywalled && !hasPaidAccess;
  }, [trialEndsAt, isPaywalled, hasPaidAccess]);

  const daysRemaining = useMemo(() => {
    if (!trialEndsAt) return null;
    const end = new Date(trialEndsAt);
    if (Number.isNaN(end.getTime())) return null;
    const diff = end.getTime() - Date.now();
    return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
  }, [trialEndsAt]);

  if (!isTrialExpiringSoon) return null;

  return (
    <Link to="/organization-settings/billing" className={classes.trialBanner}>
      Your trial ends in{' '}
      {daysRemaining === 0 ? 'less than a day' : `${daysRemaining} day${daysRemaining === 1 ? '' : 's'}`}
    </Link>
  );
}
